import { FC, ReactNode } from 'react'
import { Box, SxProps, Typography } from '@mui/material' // TODO WF-4290

type LabelProps = {
  children: ReactNode
  sx?: SxProps
  justifyContent?: 'flex-start' | 'center' | 'flex-end'
}

export const Label: FC<LabelProps> = ({
  children,
  sx,
  justifyContent = 'flex-start',
}: LabelProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent,
        alignItems: 'center',
        height: '100%',
        width: '100%',
        py: 0.5,
        ...sx,
      }}
    >
      <Typography
        sx={{
          fontWeight: 500,
          textAlign: 'left',
          maxWidth: 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontSize: 14,
          lineHeight: 1.3,
        }}
      >
        {children || ''}
      </Typography>
    </Box>
  )
}
